import { Store } from "./Store";
import { useContext, useState, useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import jwt_decode from "jwt-decode";

import AdminProtectedRoute from "./components/protectedRoute/AdminProtectedRoute";
import Header from "./components/layout/Header";
import Footer from "./components/layout/Footer";
import SideNavbar from "./components/layout/SideNavBar";
import NotFound from "./components/layout/NotFound";

import AdminLoginScreen from "./components/AdminLoginScreen";
import Dashboard from "./components/layout/Dashboard";
import UnprotectedRoute from "./components/protectedRoute/UnprotectedRoute";
import Industries from "./components/industries/Industries";
import GenerateReport from "./components/reports/GenerateReport";
import ReportArchive from "./components/reports/ReportArchive";
import CreateManualReport from "./components/reports/CreateManualReport";
import Plans from "./components/plans/Plans";
import SampleRequests from "./components/sampleRequests/SampleRequests";
import ContactRequests from "./components/contacts/ContactRequests";
import SampleRequestDetail from "./components/sampleRequests/SampleRequestDetail";
import EditReportPage from "./components/reports/EditReportPage";
import ReportRegistry from "./components/reports/ReportRegistry";

function App() {
  const { state, dispatch: ctxDispatch } = useContext(Store);
  const { token, userInfo } = state;

  useEffect(() => {
    if (!token) {
      if (localStorage.getItem("token")) {
        ctxDispatch({ type: "USER_SIGNOUT" });
        localStorage.removeItem("userInfo");
        localStorage.removeItem("token");
        localStorage.removeItem("permissions");
      }
      return;
    }
    try {
      const decoded = jwt_decode(token);
      if (decoded?.exp && decoded.exp < Date.now() / 1000) {
        ctxDispatch({ type: "USER_SIGNOUT" });
        localStorage.removeItem("userInfo");
        localStorage.removeItem("token");
        localStorage.removeItem("permissions");
      }
    } catch (error) {
      ctxDispatch({ type: "USER_SIGNOUT" });
      localStorage.removeItem("userInfo");
      localStorage.removeItem("token");
      localStorage.removeItem("permissions");
    }
  }, [token, ctxDispatch]);

  const isAuthenticated = token && userInfo;
  const pageLocation = useLocation();
  const isLoginPage = pageLocation.pathname === "/";

  const [isExpanded, setExpandState] = useState(window.innerWidth > 768);
  const sidebarHandler = () => setExpandState((prev) => !prev);

  const routeList = [
    { path: "/admin/dashboard", element: <Dashboard /> },
    { path: "/admin/industries", element: <Industries /> },
    { path: "/admin/reports/generate", element: <GenerateReport /> },
    { path: "/admin/reports/create-manual", element: <CreateManualReport /> },
    { path: "/admin/reports/archive", element: <ReportArchive /> },
    { path: "/admin/reports/edit/:slug", element: <EditReportPage /> },
    { path: "/admin/reports/registry", element: <ReportRegistry /> },
    { path: "/admin/plans", element: <Plans /> },
    { path: "/admin/sample-requests", element: <SampleRequests /> },
    { path: "/admin/contact-requests", element: <ContactRequests /> },
    { path: "/admin/sample-requests/:id", element: <SampleRequestDetail /> }
  ];

  const shouldShowSidebar = isAuthenticated && !isLoginPage;

  return (
    <div className="main-wrapper">
      {isExpanded && shouldShowSidebar && (
        <div className="sidebar-overlay" onClick={sidebarHandler}></div>
      )}
      {shouldShowSidebar && (
        <div className="sidebar-wrapper">
          <SideNavbar isExpanded={isExpanded} />
        </div>
      )}
      <div
        className={`body-wrapper ${isExpanded ? "mini-body" : "full-body"} ${
          shouldShowSidebar ? "" : "m-0"
        } d-flex flex-column`}
      >
        {shouldShowSidebar && <Header isExpanded={isExpanded} sidebarHandler={sidebarHandler} />}
        <Routes location={pageLocation} key={pageLocation.pathname}>
          <Route
            path="/"
            element={
              <UnprotectedRoute>
                <AdminLoginScreen />
              </UnprotectedRoute>
            }
          />
          {routeList.map(({ path, element }) => (
            <Route
              key={path}
              path={path}
              element={<AdminProtectedRoute>{element}</AdminProtectedRoute>}
            />
          ))}
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Footer />
      </div>
    </div>
  );
}

export default App;
